import React from 'react';
import Main from './components/Main';
import Footer from './components/Footer';

const App = () => {
    return (
        <>
            <Main />
            <Footer />
        </>
    );
};

export default App;
